module.exports = __webpack_public_path__ + "static/media/Darchviz 05.92061880.jpg";